import Basil from 'basil.js';

let basil = new Basil();

basil.setDomainCookie = (key, value, domain) => {
  if (!domain || domain === 'whitelabel') {
    domain = window.location.hostname;
  }

  if (document.domain !== 'localhost' && document.domain !== '192.168.1.105') {
    Basil.cookie.set(key, value, { domain: `.${domain}` });
  } else {
    Basil.cookie.set(key, value);
  }
};

basil.getDomainCookie = key => Basil.cookie.get(key);

basil.removeDomainCookie = key => Basil.cookie.remove(key);

export default basil;